module.exports = __webpack_public_path__ + "media/images/emblems/Personico-coat_of_arms-e58d7e825cd957f561724e715c0f458f.svg";